<script setup>

import {ref} from 'vue'

const tooltipElement = ref(null);

const props = defineProps({

  icon: {type: Boolean, default: true},
  clickToView: {type: Boolean, default: false},
  opacity: {type: String, default: '1'}
})

const mouseMove = (e) => {

  tooltipElement.value.style.cssText = "display: block;";

  let tooltipHeight = tooltipElement.value.clientHeight + 10;
  let tooltipWidth = tooltipElement.value.clientWidth;
  let cursorHorizontalPosition = e.pageX - window.scrollX -20;
//orig
  // tooltipElement.value.style.cssText += `left: ${e.pageX - window.scrollX + "px"}; top:${e.pageY - tooltipHeight + "px"}`

  if(cursorHorizontalPosition < document.body.clientWidth - 140) {
    tooltipElement.value.style.cssText += `left: ${cursorHorizontalPosition + "px"}; top:${e.clientY - tooltipHeight + "px"}`

  } else if(cursorHorizontalPosition < 1860) {
    tooltipElement.value.style.cssText += `left: ${e.pageX - window.scrollX - tooltipWidth + "px"}; top:${e.clientY - tooltipHeight + "px"}`

  } else {
    tooltipElement.value.style.cssText = "display: none;"
  }

}

const mouseOut = () => {

  tooltipElement.value.style.cssText = "display: none;"
}
</script>

<template>
  <span id="Vue-3-component-moving-tooltip" class="tooltip-wrapper">
    <span v-if="props.clickToView" @click="mouseMove" @mouseout="mouseOut"><slot></slot></span>
        <span v-else @mousemove="mouseMove" @mouseout="mouseOut"><slot></slot></span>
    <span class="tooltip-content" ref="tooltipElement"><span v-if="icon" class="tooltip-icon">&#128712 </span>
        <slot name="content"></slot>
    </span>
  </span>
</template>

<style scoped>

.tooltip-wrapper {
  cursor: pointer;
  user-select: none;
  word-break: break-word;
  width: max-content;
}

.tooltip-content {
  padding: 10px;
  box-shadow: 0 1px 4px 0 #888888;
  line-height: normal;
  opacity: v-bind(opacity);
}

.tooltip-wrapper .tooltip-content {
  position: fixed;
  border-radius: 4px;
  height: auto;
  font-size: 12px;
  color: #000000;
  background-image: linear-gradient(0deg, #f3f3f3, #ffffff);
  z-index: 9999999;
  display: none;
}

.tooltip-icon {
  color: #cc9d63;
}

</style>
